/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IbanInvoiceResponseDto } from '../models';
// @ts-ignore
import type { IbanQrAddCommand } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
/**
 * IbanQrApi - axios parameter creator
 * @export
 */
export const IbanQrApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrIbanInvoiceUidGet: async (ibanInvoiceUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanInvoiceUid' is not null or undefined
            assertParamExists('apiIbanQrIbanInvoiceUidGet', 'ibanInvoiceUid', ibanInvoiceUid)
            const localVarPath = `/api/iban-qr/{ibanInvoiceUid}`
                .replace(`{${"ibanInvoiceUid"}}`, encodeURIComponent(String(ibanInvoiceUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanQrAddCommand} [ibanQrAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrPost: async (ibanQrAddCommand?: IbanQrAddCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanQrAddCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IbanQrApi - functional programming interface
 * @export
 */
export const IbanQrApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IbanQrApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanQrApi.apiIbanQrIbanInvoiceUidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanQrAddCommand} [ibanQrAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanQrPost(ibanQrAddCommand?: IbanQrAddCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanQrPost(ibanQrAddCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanQrApi.apiIbanQrPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IbanQrApi - factory interface
 * @export
 */
export const IbanQrApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IbanQrApiFp(configuration)
    return {
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceResponseDto> {
            return localVarFp.apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanQrAddCommand} [ibanQrAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanQrPost(ibanQrAddCommand?: IbanQrAddCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIbanQrPost(ibanQrAddCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IbanQrApi - object-oriented interface
 * @export
 * @class IbanQrApi
 * @extends {BaseAPI}
 */
export class IbanQrApi extends BaseAPI {
    /**
     * 
     * @param {string} ibanInvoiceUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanQrApi
     */
    public apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig) {
        return IbanQrApiFp(this.configuration).apiIbanQrIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanQrAddCommand} [ibanQrAddCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanQrApi
     */
    public apiIbanQrPost(ibanQrAddCommand?: IbanQrAddCommand, options?: RawAxiosRequestConfig) {
        return IbanQrApiFp(this.configuration).apiIbanQrPost(ibanQrAddCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

